import iconClock from "../../../assets/images/100-clock.svg";
import iconMeetingLive from "../../../assets/images/meeting-live.svg";
import { useGlobal } from "../../../contexts/globalContext";

export const CurrentMeetingDetails = () => {
  const { SCREEN_STATE } = useGlobal();
  const getScreenMode = () => (SCREEN_STATE.selectedId === 106 ? "REWIND" : "LIVE");
  return (
    <div className="flex-col space-between p-r-10 p-l-12 m-t-8 m-b-8">
      <div className="meeting-status-box-title">Lorem.</div>
      <div className="flex h-12 lh-12">
        <div className="align-items-center">
          <img src={iconMeetingLive} width={6} height={6} className="m-r-3" alt="" />
          <div className="m-r-3 font-8">{getScreenMode()}</div>
        </div>
        <div className="align-items-center m-l-12">
          <img src={iconClock} width={8.75} height={8.75} className="m-r-3" alt="" />
          <div className="font-8">{SCREEN_STATE.time || "00:00:00"}</div>
        </div>
      </div>
    </div>
  );
};
